/**
 * @param {{[key: string]: boolean}} selectionMap
 */
export const isEverythingSelected = (selectionMap) =>
  !Object.values(selectionMap).includes(false);
